import React from 'react';
import { connect } from "react-redux";
import { useEffect } from "react";

import {
    Box,
    Button,
    Chip,
    Container,
    Divider,
    Grid,
    Stack,
    Typography,
    CircularProgress,
} from '@mui/material';
import { useImmer } from 'use-immer';
import '../MyBooksComponent/MyBooksComponent.css';
import { getBook, getBookdetails } from '../../store/actions/book.js';
import NoDataFound from '../../assets/no-data-found.png';
import { setorderBookingDetails } from '../../store/actions/book.js';
import { makeStyles } from '@material-ui/core/styles';
import * as config from "../../assets/js/constant.js";
import { useParams, useNavigate } from "react-router-dom";


const useStyles = makeStyles({
    root: {
        borderRadius: '50px',
        color: '#010101 !important',
        borderColor: '#D9D9D9 !important'
    },
    button: {
        "&.active": {
            color: '#ffffff',
        },
    },
});

const MyBooksComponent = ({ getBook, bookList, bookOrderDetails, setorderBookingDetails, bookName }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [getloader, setloader] = useImmer(true);
    const [dataFetched, setDataFetched] = useImmer(false);
    const [addedBooks, setAddedBooks] = useImmer([]);
    const [hoveredBook, setHoveredBook] = useImmer(null);
    const [bookCounts, setBookCounts] = useImmer(bookOrderDetails);



    // The book fetching logic remains
    useEffect(() => {
        const fetchData = async () => {
            setloader(true);
            await getBook();
            setTimeout(() => {
                setloader(false);
                setDataFetched(true);
            }, 2000);
        };

        fetchData();
    }, [getBook]);

    // The handleClickBooks and handleReset functions remain but might need review 
    // depending on the overall app flow if the 'Submit' and 'Reset' buttons are kept.
    // I've kept them for now, but their functionality relies on `bookOrderDetails`.

    function handleClickBooks() {
        if (bookOrderDetails.length === 0) {
            alert("Please add at least one book before proceeding!"); // Optional alert message
            return;
        }
        navigate(`/get-books/my-books-orders/`);
    }


    function handleReset() {
        // Clear local states
        setAddedBooks([]);
        setBookCounts({});

        // Dispatch Redux action to reset bookOrderDetails
        setorderBookingDetails([]);
    }

    // Since the increment/decrement functionality is removed, these handlers are removed 
    // or simplified to only handle navigation/viewing if needed.
    const handleRemoveBook = (bookName) => {
        const bookToRemove = bookOrderDetails.find(book => book.BookName === bookName);
        if (bookToRemove) {
            setorderBookingDetails({ ...bookToRemove, remove: true });
        }
    };

    // const handleIncrement = (book) => { ... }; // Removed
    // const handleDecrement = (book) => { ... }; // Removed

    // Keeping this useEffect to sync local states with Redux for the Shopping Cart *display* (Chips)
    useEffect(() => {
        // Sync `addedBooks` and `bookCounts` with Redux state
        setAddedBooks(bookOrderDetails.map((order) => order.BookName));
        setBookCounts((draft) => {
            const newBookCounts = {};
            bookOrderDetails.forEach((order) => {
                newBookCounts[order.BookID] = order.Copy;
            });
            return newBookCounts; // Set the draft to the new object
        });
    }, [bookOrderDetails]);


    return (
        <Box className="book-gallery-page">
            <Container sx={{ px: 1 }}>
                {/* --- SHOPPING CART SECTION REMAINS --- */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
                    <Typography sx={{ backgroundColor: '#686868', padding: '6px 12px', borderRadius: '40px', color: '#ffffff' }}>Shopping Cart</Typography>
                </Box>
                <Box>
                    <Box sx={{ py: 2 }}>
                        {bookOrderDetails.length === 0 ? (
                            <Typography sx={{ color: '#686868', textAlign: 'left', mb: 1.5, fontWeight: 500 }}>You have not selected any book yet.<br />Please make your selection below.</Typography>
                        ) : (
                            <Typography variant="body1" sx={{ color: '#686868', textAlign: 'left', mb: 1.5, fontWeight: 500 }}>
                                You have selected these books:
                            </Typography>
                        )}
                        <Stack direction="column" spacing={1} sx={{ flexWrap: 'nowrap' }}>
                            {bookOrderDetails.map((order, index) => (
                                <Box key={index} sx={{ width: 'fit-content' }}> {/* Optional: helps contain the width */}
                                    <Chip
                                        label={`${order.BookName} - ${order.Copy} ${order.Copy === 1 ? 'copy' : 'copies'}`}
                                        onDelete={() => handleRemoveBook(order.BookName)}
                                        sx={{
                                            backgroundColor: '#84AEE1',
                                            color: '#ffffff',
                                            // *** CRITICAL CHANGE: Remove width: '100%' ***
                                            // The Chip will now shrink to fit its content.
                                            // Remove justify-content, padding, and other width-forcing styles
                                            mr: 1,
                                            // Use Stack spacing instead of Chip margin for better control

                                            '& .MuiChip-deleteIcon': {
                                                color: '#ffffff',
                                            },
                                        }}
                                    />
                                </Box>
                            ))}
                        </Stack>
                    </Box>
                    <Box sx={{ my: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                        <Typography sx={{ color: 'red', fontSize: '0.9rem', textAlign: 'left' }}>
                            Shipping is currently available within India only.
                        </Typography>
                        <Button onClick={handleClickBooks} variant="contained" sx={{ borderRadius: '40px', px: 6, py: 1, backgroundColor: '#3875BF' }}>Submit</Button>
                    </Box>
                    <Box sx={{ my: 2 }}>
                        <Divider />
                    </Box>
                </Box>
                {/* --- END SHOPPING CART SECTION --- */}


                {/* --- BOOK GALLERY SECTION --- */}
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2 }}>
                        <Typography sx={{ backgroundColor: '#686868', padding: '6px 12px', borderRadius: '40px', color: '#ffffff' }}>Book Gallery</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <Button
                                variant="outlined"
                                className={classes.root}
                                onClick={handleReset} // Attach reset handler
                                sx={{ borderRadius: '50px' }}
                            >
                                Reset
                            </Button>

                        </Box>
                    </Box>

                    {getloader ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        dataFetched && (!bookList || bookList.length === 0) ? (
                            <Box
                                className="noBookFound"
                                sx={{
                                    mb: 5,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '300px',
                                }}
                            >
                                <img className="noDataFound" src={NoDataFound} alt="nodatafound" />
                                <Typography sx={{ color: '#8E8E8E', fontSize: '1.2rem', fontWeight: 500 }}>No book found!</Typography>
                            </Box>
                        ) : (
                            dataFetched && bookList.length > 0 ? (
                                <Box className="book-gallery-container">
                                    <Grid container spacing={1}>
                                        {bookList.map((book) => (
                                            <Grid item xs={6} md={2.4} key={book.BookID}>
                                                <Box
                                                    className="book-gallery-section"
                                                    sx={{
                                                        backgroundColor: '#ffffff',
                                                        textAlign: 'center',
                                                        py: 1,
                                                        px: 1,
                                                        borderRadius: '4px',
                                                        // Apply the navigation logic here
                                                        cursor: 'pointer' // Add a pointer cursor to indicate clickability
                                                    }}
                                                    onClick={() => navigate(`/get-books/book-description/${book.BookID}`)} // Add onClick to the main container
                                                >

                                                    {/* Book Image */}
                                                    <Box>
                                                        <img
                                                            className="book-image"
                                                            src={config.image + book.Image}
                                                            alt="BooksImage"
                                                            title="View Description"
                                                        />
                                                    </Box>

                                                    <Box sx={{ textAlign: 'center', pb: 1.5 }}>
                                                        <Typography className="book-name" sx={{ px: 1 }}>
                                                            {book.BookName}
                                                        </Typography>
                                                    </Box>

                                                    {/* Book Amount */}
                                                    <Box sx={{ textAlign: 'center' }}>
                                                        <Typography
                                                            className="donation-btn"
                                                            sx={{ border: '1px solid #3875BF', borderRadius: '40px', textTransform: 'capitalize', mb: 0, color: '#3875BF', fontWeight: '500', padding: '6px 8px' }}
                                                        >
                                                            Suggested Donation | ₹{book.Amount}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            ) : null
                        )
                    )}
                </Box>
                {/* --- END BOOK GALLERY SECTION --- */}
            </Container>
        </Box>
    )
}

const mapStateToProps = (state) => ({
    bookList: state.book.bookList,
    bookOrderDetails: state.book.bookOrderDetails
});

export default connect(mapStateToProps, { getBook, setorderBookingDetails, getBookdetails })(MyBooksComponent);